//OIDC implicit flow user manager config
export function setUserManagerConfig(userManagerConfig) {
    sessionStorage.setItem("userManagerConfig", JSON.stringify(userManagerConfig));
}

export function getUserManagerConfig() {
    return JSON.parse(sessionStorage.getItem("userManagerConfig"));
}

//loggedInUser
export function setLoggedInUser(loggedInUser) {
    var hubMap = new Map();
    var hubList = new Map();
    for (var i = 0; i < loggedInUser.hubs.length; i++) {
        var acls = loggedInUser.hubs[i].acls;
        var aclsMap = new Map();
        for (var j = 0; j < acls.length; j++) {
            aclsMap.set(acls[j].functionName, acls[j].access);
        }
        hubMap.set(loggedInUser.hubs[i].code, aclsMap);
        hubList.set(loggedInUser.hubs[i].code, loggedInUser.hubs[i].name);
    }
    loggedInUser.hubMap = JSON.stringify(hubMap);
    loggedInUser.hubList = JSON.stringify(hubList);
    sessionStorage.setItem("loggedInUser", JSON.stringify(loggedInUser));
}

export function getLoggedInUser() {
    return JSON.parse(sessionStorage.getItem("loggedInUser"));
}

//HubMap
export function getHubMap() {
    return new Map(JSON.parse(getLoggedInUser().hubMap));
}

export function getHubList() {
    return new Map(JSON.parse(getLoggedInUser().hubList));
}

//selected Hub
export function setSelectedHub(selectedHub) {
    return sessionStorage.setItem("selectedHub", selectedHub);
}

export function getSelectedHub() {
    return sessionStorage.getItem("selectedHub");
}

//selected hub for UI display
export function getSelectedHubValue() {
    return getHubList().get(sessionStorage.getItem("selectedHub"));
}

//id_token
export function setToken(id_token) {
    return sessionStorage.setItem("id_token", id_token);
}

export function getToken() {
    return sessionStorage.getItem("id_token");
}
